import axiosInstance from './axiosConfig';

export interface GoldenDemand {
  id: string;
  name: string;
  description: string;
  full_text: string;
  processed: boolean;
  markdown_transform_id?: string;
  created_at: string;
  modified_at: string;
}

export interface UploadGoldenDemandParams {
  file: File;
  name: string;
  description?: string;
}

export const uploadGoldenDemand = async (
  params: UploadGoldenDemandParams,
): Promise<GoldenDemand> => {
  const formData = new FormData();
  formData.append('file', params.file);

  const data = {
    name: params.name,
    description: params.description || '',
  };

  formData.append('data', JSON.stringify(data));

  const response = await axiosInstance.post('/api/golden-demands/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const getGoldenDemands = async (filters?: {
  processed?: boolean;
}): Promise<{ gold_standards: GoldenDemand[]; total: number }> => {
  const params = new URLSearchParams();

  if (filters?.processed !== undefined) {
    params.append('processed', filters.processed.toString());
  }

  const response = await axiosInstance.get(
    `/api/golden-demands/?${params.toString()}`,
  );
  // ViewSet returns {gold_standards: [...]} format from GoldStandardListResponse
  return {
    gold_standards: response.data.gold_standards || [],
    total: response.data.total || (response.data.gold_standards || []).length,
  };
};

export const getGoldenDemand = async (id: string): Promise<GoldenDemand> => {
  const response = await axiosInstance.get(`/api/golden-demands/${id}/`);
  return response.data;
};

export const deleteGoldenDemand = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/api/golden-demands/${id}/`);
};
